<template>
  <div>
<!--    <div>-->
<!--    <div class="remington-typed-font full-height text-align-center">-->
<!--      <div class="inline-block margin-auto width-90 full-height vertical-middle">-->
<!--        <nav class="navigationList inline-block">-->
<!--          <ul>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'AboutUS'}">General</router-link></li>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'StructureMain'}">Structure</router-link></li>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'CampaignsMain'}">Campaigns</router-link></li>&lt;!&ndash;              <li>|</li>&ndash;&gt;-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'ProceduresMain'}">Procedures</router-link></li>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'RulesMain'}">Rules</router-link></li>-->
<!--          </ul>-->
<!--        </nav>-->
<!--      </div>-->
<!--    </div>-->
<!--    </div>-->
  <div class="typed-on-paper-a4">
    <div class="text-align-center">
      <h1>DOCUMENTATION ARCHIVE</h1>
    </div>
    <br><br>
    <div class="text-align-left">
      <p>
        This is the "Flying Tin Cans" Archive. Here you will find all manner of information, pertaining to how we operate.
      </p>
<!--      <p>The tabs at the top of this page control the categories of information that is available, whereas-->
<!--      the tabs at the side of the page control the different information included under each category.</p>-->
<!--      <br>-->
      <p>The page is heavily under construction and will change multiple times in the coming months as more
      information is added. The idea is to have everything that one might need at a centralized location in our Database.</p>
    </div>
    <DivLinkButton
      class="padding-0-10"
      route-name="CommunicationsSetup"
    >
      <h1 class="heading">How to set up your Teamspeak Communications for the Campaign</h1>
      <p class="text-align-left">
        Before you can take part in the FTC Campaign, you will need to set up your Teamspeak settings. We enforce a Push-To-Talk environment in our Campaign channels. You will also need to set hotkeys so you can change channels while flying.
      </p>
    </DivLinkButton>
    <DivLinkButton
      class="padding-0-10"
      route-name="CampaignSkins"
    >
      <h1 class="heading">How to get the skins available for the Campaign</h1>
      <p class="text-align-left">
        We use a variety of custom made skins for our Campaigns. We are currently using Haluter's Skin Downloader to share these with our members. This is a guide on how to use the software and access the FTC custom skins.
      </p>
    </DivLinkButton>
    <DivLinkButton
      class="padding-0-10"
      route-name="CampaignRules"
    >
      <h1 class="heading">Campaign Rules</h1>
      <p class="text-align-left">
        This page displays some of the basic rules our Campaign enforces. These rules help us to offer the most immersive multi-player experience in combat flying simulation.
      </p>
    </DivLinkButton>
    <DivLinkButton
      class="padding-0-10"
      route-name="RulesOfEngagement"
    >
      <h1 class="heading">Rules of Engagement (ROE)</h1>
      <p class="text-align-left">
        There are however some limitations that we cannot overcome within the game itself. We therefore also have a number of rules that regulate the engagements that take place in our Campaign.
        These rules help us provide a fun and fair environment for our members.
      </p>
    </DivLinkButton>
    <DivLinkButton
      class="padding-0-10"
      route-name="CommunityBehaviourRules"
    >
      <h1 class="heading">Community Behaviour Rules</h1>
      <p class="text-align-left">
        Our Community Rules exist to provide guidelines towards what we would consider implicit in normal behaviour and to provide recourse for anyone who does feel genuinely aggrieved by any behaviour or incident.
      </p>
    </DivLinkButton>
  </div>
  </div>
</template>

<script>

  import DivLinkButton from "../basic_comp/DivLinkButton";

  export default {
    name: "InfoTemplate",
    components: {
      DivLinkButton
    }
  }
</script>

<style scoped>

.iconImage {
  max-height: 40px;
}

.navbar-tabs {
  min-height: 0px;
  width: calc(100% - 0px); /* Whished widht in % minus 2x border size */
  padding: 20px;
  padding-bottom: 15px;
  font-family: "Remingtoned Type";
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-image: url("/frontend/src/assets/images/ftcpaper-tabs.png");
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);*/
  box-shadow: 0px -5px 15px rgba(10,10,10,0.3);
  color: #1b1b1b;
}

.navigationList li {
  display: table-cell;
  font-size: 125%;
  text-align: center;
}

.navigationList li a {
  padding: 0px 40px;
  text-decoration: none;
  font-weight: bold;
  color: #1b1b1b;
}

.navigationList li a:hover{
  color: #1b1b1b;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  /*border-top-left-radius: 15px;*/
  /*border-top-right-radius: 15px;*/
  border-radius: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/info/InfoTemplate.vue